import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Sidebar, DRAWER_WIDTH } from './Sidebar';
import { Header } from './Header';
import { CommandPalette } from '@/components/CommandPalette';
import { useAuth } from '@/auth/context';

const LayoutRoot = styled(Box)(({ theme }) => ({
  display: 'flex',
  minHeight: '100vh',
  backgroundColor: theme.palette.background.default,
}));

const MainArea = styled('main')(({ theme }) => ({
  flexGrow: 1,
  minHeight: '100vh',
  width: '100%',
  [theme.breakpoints.up('md')]: {
    width: `calc(100% - ${DRAWER_WIDTH}px)`,
  },
}));

// Narrower on a phone, where every pixel above the check-in camera counts.
const ContentArea = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(3),
  },
}));

const titleMap: Record<string, string> = {
  '/users': 'Users',
  '/transactions': 'Transactions',
  '/accounts': 'Accounts',
  '/conversations': 'Conversations',
  '/flagged': 'Flagged Conversations',
  '/feedback': 'Feedback',
  '/nim': 'Nim',
  '/nudges': 'Nudges',
  '/referrals': 'Referrals',
  '/fflags': 'Feature Flags',
  '/rewards': 'Partner Rewards',
  '/events': 'Event check-in',
  '/system': 'System',
};

export function PageLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user, logout } = useAuth();
  const location = useLocation();

  const title = Object.entries(titleMap).find(
    ([path]) => location.pathname === path || location.pathname.startsWith(path + '/')
  )?.[1] ?? 'Admin';

  return (
    <LayoutRoot>
      <CommandPalette />
      <Sidebar
        userEmail={user?.email ?? ''}
        onLogout={logout}
        open={sidebarOpen}
        setOpen={setSidebarOpen}
        currentPath={location.pathname}
      />
      <MainArea>
        <Header title={title} onMenuClick={() => setSidebarOpen(true)} />
        <ContentArea>
          <Outlet />
        </ContentArea>
      </MainArea>
    </LayoutRoot>
  );
}
